import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

/** A header checkbox: checked when every row is, a dash when only some are. */
export function SelectAllBox({
  label,
  all,
  some,
  onChange,
}: {
  label: string;
  all: boolean;
  some: boolean;
  onChange: (on: boolean) => void;
}) {
  const state = all ? true : some ? "indeterminate" : false;
  return (
    <CheckboxPrimitive.Root
      aria-label={label}
      checked={state}
      // A partial selection clears on click, like a full one.
      onCheckedChange={() => onChange(!(all || some))}
      className={cn(
        "grid h-4 w-4 shrink-0 place-content-center rounded-sm border border-slate-300 shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        "data-[state=checked]:border-indigo-600 data-[state=checked]:bg-indigo-600 data-[state=checked]:text-white",
        "data-[state=indeterminate]:border-indigo-600 data-[state=indeterminate]:bg-indigo-600 data-[state=indeterminate]:text-white",
      )}
    >
      <CheckboxPrimitive.Indicator className="grid place-content-center text-current">
        {state === "indeterminate" ? <Minus className="h-3.5 w-3.5" /> : <Check className="h-3.5 w-3.5" />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
